import type { AxiosRequestConfig } from 'axios';
import z from 'zod';
import { api } from '../../axios.instance';
import { responseContract } from '../../lib';
import { UserDtoSchema } from '../contracts';

const _GetUserByIdRequestDtoSchema = z.object({
  id: z.number(),
});

const GetUserByIdResponseDtoSchema = UserDtoSchema;

export type GetUserByIdRequestDto = z.infer<
  typeof _GetUserByIdRequestDtoSchema
>;
export type GetUserByIdResponseDto = z.infer<
  typeof GetUserByIdResponseDtoSchema
>;

export const getUserById = (
  dto: GetUserByIdRequestDto,
  config?: AxiosRequestConfig<GetUserByIdRequestDto>
) => {
  return api
    .get(`/users/${dto.id}`, config)
    .then(responseContract(GetUserByIdResponseDtoSchema));
};
